import ajaxService from '../../../services/ajaxService';
import EmailPasswordForm from './EmailPasswordForm';
import FormWithPasswordConfirmation from './FormWithPasswordConfirmation';

class RegistrationForm extends EmailPasswordForm {
	#formWithConfirmPassword;
	
	/**
	 * @param {Element} registrationForm
	 * @param {Object}  params
	 */
	constructor(registrationForm, params) {
		super(registrationForm, params);
		
		this.#formWithConfirmPassword = new FormWithPasswordConfirmation(registrationForm);
	}
	
	/**
	 * @returns {Promise<!{response, xhr}>}
	 */
	sendCustomXhrRequest() {
		const formData = new FormData(this.getForm());
		
		return ajaxService.sendPost({
			'url' : 'user/register',
			'data': {
				'email'          : formData.get('email'),
				'password'       : formData.get('password'),
				'wantsNewsletter': formData.get('newsletter') === 'on'
			}
		});
	}
	
	/**
	 * @returns {boolean}
	 */
	isValidForm() {
		return super.isValidForm() && this.#formWithConfirmPassword.doPasswordsMatch();
	}
	
}

export default RegistrationForm;